// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desktop-container-module__root--16NSP{display:none}@media screen and (min-width:756px){.desktop-container-module__root--16NSP{display:flex;justify-content:space-between;width:100%;overflow-x:auto}}.desktop-container-module__middleBlock--RpDqx{flex-shrink:1;overflow-x:auto;padding:0 30px;display:inline-flex;flex-direction:column;align-items:center}@media screen and (min-width:756px) and (max-width:1151px){.desktop-container-module__middleBlock--RpDqx{display:none}}.desktop-container-module__group--2tYqm:not(:last-child){margin-bottom:50px}", ""]);
// Exports
exports.locals = {
	"root": "desktop-container-module__root--16NSP",
	"middleBlock": "desktop-container-module__middleBlock--RpDqx",
	"group": "desktop-container-module__group--2tYqm"
};
module.exports = exports;
